import * as $ from 'jquery';
import onDocumentLoaded from "../lib/onDocumentLoaded";

import {Analytics} from "@plaudit/analytics";
Analytics.setup(); // This will setup the system and return an instance of Analytics.

/**
 * Gravity Forms
 * 
 * Include this in MySite.php::__construct():
	add_filter('gform_confirmation', function( $confirmation, $form, $entry, $ajax ) {
		$confirmation .= "<span class=\"gravityFormConfirmation\" data-gravityform-title=\"".$form["title"]."\" data-gravityform-id=\"".$form['id']."\"/>";
		return $confirmation;
	}, 10, 4);
*/
function onCheckForGravityFormConfirmation() {
	const confirmations = document.querySelectorAll(".gravityFormConfirmation");
	for (let i=0; i < confirmations.length; i++) {
		const confirmation = confirmations[i];
		if (confirmation !== undefined && confirmation instanceof HTMLElement) {
			// Remove so it is not processed again
			confirmation.remove();

			// Process it
			const formTitle = confirmation.dataset.gravityformTitle;
			const formId = confirmation.dataset.gravityformId;
			const analytics = Analytics.getInstance();
			analytics.trackEvent("Gravity Form", "Confirmation", `${formTitle} (ID: ${formId})`);
		}
	}
}

onDocumentLoaded(document, onCheckForGravityFormConfirmation);
$(document).on("gform_confirmation_loaded", onCheckForGravityFormConfirmation);